// extracted by mini-css-extract-plugin
export default {"Home":"home_Home__xIvyD"};